module.exports = __webpack_public_path__ + "img/mask.ffb222a6.svg";